import assetActions from './assetActions'
import drawersActions from './drawersActions'

const allActions = {
    assetActions,
    drawersActions,
}

export default allActions
